<template lang="pug">
md-dialog#general-form-wrapper(:md-click-outside-to-close='true', :ref='dialogRef')
    md-dialog-content
    loader(:loading='loading', :size='45')
        md-dialog-actions
            md-button.md-primary.md-raised.button(@click='closeDialog') X

        h1.title {{ seriesName }}
        md-dialog-title.md-headline(v-if="associatedData.length > 0")
            div.info(v-for="(season, idxSeason) in associatedData")
                h3.season(v-if="season.seasonNumber", @click="changeShowItem(idxSeason)") Season {{ season.seasonNumber }}
                div(v-for="video in season.videos")
                    a.videos.info(v-if="showItem && idxSeason === indexSeason", target="_blank", rel="noopener noreferrer", :href='`video/${video.id}`') {{video.episodeNumber}} - {{ video.name }}
                div(v-if="!season.seasonNumber", v-for="video in season.videos")
                    a.videos.info(target="_blank", rel="noopener noreferrer", :href='`video/${video.id}`') {{video.episodeNumber}} - {{ video.name }}
        md-layout(v-else, md-align='center')
            span#no-results
                md-icon.md-accent(md-iconset="fa fa-exclamation-circle")
                |  No items to show
</template>

<script>
import uuid from 'uuid';
import mediaItemService from '../../services/mediaItemService';
import Loader from '../../shared-components/Loader';

export default {
    components: {
        Loader
    },
    props: {},
    data() {
        return {
            dialogRef: uuid.v4(),
            seriesId: null,
            associatedData: [],
            loading: false,
            seriesName: null,
            showItem: false,
            indexSeason: null,
            currentIndex: null
        };
    },
    methods: {
        closeDialog() {
            const ref = this.dialogRef;
            this.$refs[ref].close();
            this.$emit('closed');
        },
        openDialog(seriesId, seriesName) {
            this.loading = true;
            this.seriesId = seriesId;
            this.seriesName = seriesName;
            const ref = this.dialogRef;
            this.$refs[ref].open();
            this.fetch();
        },
        changeShowItem(idx){
            if(this.currentIndex === idx){ 
                this.currentIndex = idx
                this.indexSeason = idx
                this.showItem = !this.showItem
            }
            else{
                this.currentIndex = idx
                this.showItem = true
                this.indexSeason = idx
            }
        },

        fetch() {
            // Get the data
            mediaItemService.getAssociatedSeries(this.seriesId)
                .then((response) => {
                    this.associatedData = response.data.data
                    this.loading = false;
                })
        },
    },
};
</script>
<style lang="scss" scoped>
.md-dialog-content{
    padding: 0px;
}

.button{
    border-radius: 5px;
    padding: 0px;
    font-size: large;
}
.test{
    background-color: aqua;
}
.title {
    display: flex;
    justify-content: center;
    font-style: italic;
    color: rgb(58, 57, 57);
}

.info {
    font-size: 16px;
    margin-top: 10px;
    margin-left: 8px;
}

.videos{
    display: block;
    display: flex;
    justify-content: center;
    padding: 5px;
    margin: 10px;
    text-decoration: none;
    color: rgb(58, 57, 57) !important;
    transition: all 400ms;
}
.videos:hover{
    margin-left: 5%;
    margin-right: 5%;
    border-radius: 6px;
    font-size: 17px;
    font-weight: 600;
    background-color: rgb(244, 240, 240);
    text-decoration: none !important;
}
.season{
    border-radius: 6px;
    background-color: #eee;
    color: rgb(58, 57, 57);
    margin: 0 3%;
    padding: 5px;
}
.season:hover{
    cursor: pointer;
    background-color: #eee;
}
.md-headline {
    height: 55vh;
    overflow-y: auto;
}
#no-results {
    padding: 20px;
    .md-icon {
        margin-right: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/shared-components/serie/InfoSeriesDialog.vue